import { Dayjs } from "dayjs";

export type CitizenForm = {
  nin: string;
  bvn: string;
  name: string;
  date: Dayjs | null;
  identificationDocument: string;
  passportExpiryDate: Dayjs | null;
  passportNumber: string;
  passportDocument: string;
  driverLicenceNumber: string;
  driverLicenceExpiryDate: Dayjs | null;
  driverLicenceFront: string;
  driverLicenceBack: string;
  votersNumber: string;
  votersCardFront: string;
  votersCardBack: string;
  nationalIdCardFront: string;
  nationalIdCardBack: string;
};

export type CitizenFormKey = keyof CitizenForm;

export type ErrorMessages = {
  [key in CitizenFormKey]?: { [k: string]: string };
};

export type FieldRules = {
  [key in CitizenFormKey]?: RegExp;
};

export type FieldErrors = {
  [key in CitizenFormKey]: { hasError: boolean; message: string };
};

export enum IdentificationDocumentType {
  DriversLicense = "DRIVERS_LICENSE",
  InternationalPassport = "INTERNATIONAL_PASSPORT",
  VotersCard = "VOTERS_CARD",
  NationalIdCard = "NATIONAL_ID_CARD",
}
